import script from "./AuthenticatedFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticatedFooter.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticatedFooter.vue?vue&type=style&index=0&id=ea75a854&scope=true&lang=css"

const __exports__ = script;

export default __exports__